import PlayTriangle from './PlayTriangle'

export default PlayTriangle
// eslint-disable-next-line import/export
export * from './PlayTriangle'
